import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api'
import { CourseBundleInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { coursesDependencies } from '../../../constants/courses-dependencies'

export function useCourseBundle(id: string) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CourseBundleInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: courseBundleData, mutate } = useControlledSwr(
    () => [`${COURSE_BUNDLES_API}/${id}`, RequestModuleEnum.CourseBundle, ...coursesDependencies],
    fetcher,
    undefined,
    !!user,
  )

  return { courseBundleData, mutate }
}
